































































import { BaseField, BaseDurationInput, LinearLayout, ClickEvent } from '@revas/reef'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import VueI18n from 'vue-i18n'

@Component({
  components: {
    BaseField,
    BaseDurationInput,
    LinearLayout
  }
})
export default class AppWeeklyDurationsForm extends Vue {
  @Prop({ default () { return [0, 0, 0, 0, 0, 0, 0] } }) readonly weeklyDurations!: number[]
  @Prop() readonly i18n!: VueI18n

  updatedWeeklyDurations: number[] = []
  @Watch('weeklyDurations', { immediate: true })
  onChange (weeklyDurations: number[]) {
    this.updatedWeeklyDurations = weeklyDurations
  }

  updateWeeklyDurations ($event: ClickEvent<string>, week: number) {
    this.$set(this.updatedWeeklyDurations, week, $event.value)
  }

  emitWeeklyDurations () {
    this.$emit('change', this.updatedWeeklyDurations)
  }
}
